import { Dispatch } from "redux";
import TeachrRepository from "../../Repositories/TeachrRepository";
import { DispatchClientParams } from "../../config/CLIENT_TYPE_CONFIG";

export const GET_ALL_CLIENTS = "GET_ALL_CLIENTS";
export const GET_CHILD_ACTIVE_ONLY_ACTIF = "GET_CHILD_ACTIVE_ONLY_ACTIF";
export const DELETE_CLIENT = "DELETE_CLIENT";

interface GetAllClientsAction {
  type: typeof GET_ALL_CLIENTS;
  payload: any;
}
interface GetChildActiveOnlyActifAction {
  type: typeof GET_CHILD_ACTIVE_ONLY_ACTIF;
  payload: any;
}

export type GetAllClientsActionTypes = GetAllClientsAction;
export type GetChildActiveOnlyActifActionTypes = GetChildActiveOnlyActifAction;

export const getAllClients = (params: DispatchClientParams) => {
  return async (dispatch: Dispatch<GetAllClientsActionTypes>) => {
    try {
      if (!params.teachrId) return;
      const clients = await TeachrRepository.getAllClientsForTeachr(params)
      dispatch({ type: GET_ALL_CLIENTS, payload: clients });
    } catch (error) {
      console.error("Erreur lors de la récupération des client actifs :", error);
    }
  };
};
export const getActiveClients = (params: DispatchClientParams) => {
  return async (dispatch: Dispatch<GetChildActiveOnlyActifActionTypes>) => {
    try {
      if (!params.teachrId) return;
      const activeClients = await TeachrRepository.getAllClientsForTeachr(params)
      dispatch({ type: GET_CHILD_ACTIVE_ONLY_ACTIF, payload: activeClients });
    } catch (error) {
      console.error("Erreur lors de la récupération des client actifs :", error);
    }
  };
};


export const resetAllClients = () => {
  return async (dispatch: Dispatch<GetAllClientsActionTypes>) => {
      dispatch({ type: GET_ALL_CLIENTS, payload: null });
  };
};
export const resetActiveClients = () => {
  return async (dispatch: Dispatch<GetChildActiveOnlyActifActionTypes>) => {
    dispatch({ type: GET_CHILD_ACTIVE_ONLY_ACTIF, payload: null });
  };
};


